import { ACTION_TYPES } from './store/action';
import { financialApi } from '../api';
import { IUserInfo } from './../../contract/model/userInfo.model';
import { updateUserInfo } from 'app/modules/contract/service/index';
import { IPaymentModel } from '../model/payment.model';
import { updateSellingPointInfoBank } from 'app/modules/sellingPoint/service/sellingPointService';

export const checkBicAndIban = (userInfo: IUserInfo) => async dispatch => {
  const checked = await financialApi.checkBicIban(userInfo);
  if (checked.data) {
    await dispatch(updateUserInfo(userInfo,""));
    return checked.data;
  } else {
    return checked.data;
  }
};

export const checkBicAndIbanSellingPoint = (userInfo: any) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.RESET_ERROR,
  });

  const checked = await financialApi.checkBicIban(userInfo);
  console.log(checked)
  if (checked.data) {
    await dispatch(updateSellingPointInfoBank(userInfo));
    return checked.data;

  } else {
  
    await dispatch({
      type: ACTION_TYPES.SET_ERROR,
      payload: { error: 'IBAN Non correcte' },
    });
    return checked.data;
  }
};

export const getHashMack = (paymentModel: IPaymentModel, dispatch) =>
  new Promise<void>((resolve, reject) => {
    dispatch({
      type: ACTION_TYPES.GET_HMAK,
      payload: financialApi.getHashMack(paymentModel),
    });
    resolve();
  });
